var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRipple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xrp-xrp-logo 2",
    clipPath: "url(#clip0_721_107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0707 0H19.9613L13.9457 6.47321C11.7672 8.81618 8.23516 8.81618 6.05508 6.47321L0.0371094 0H2.93008L7.50039 4.91731C8.16628 5.63056 9.06368 6.0304 9.99863 6.0304C10.9336 6.0304 11.831 5.63056 12.4969 4.91731L17.0707 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.89258 18H0L6.05469 11.4869C8.2332 9.14392 11.7652 9.14392 13.9453 11.4869L20 18H17.1094L12.5 13.0428C11.8341 12.3295 10.9367 11.9297 10.0018 11.9297C9.06681 11.9297 8.16941 12.3295 7.50352 13.0428L2.89258 18Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_721_107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRipple);
export default __webpack_public_path__ + "static/media/ripple.247e52e4cc0933be99f0d4e2fdb0ca62.svg";
export { ForwardRef as ReactComponent };